import styled, { DefaultTheme } from 'styled-components'
import ColorPalette from '~/styles/colorPalette'
import { HeightClass } from '~/utils/enum/classes'

function validationBgColor(
  progress: number,
  theme: DefaultTheme,
  isError?: boolean
) {
  if (isError) return theme.progressBar.errorColor

  return progress === 100
    ? theme.progressBar.loadedColor
    : theme.progressBar.loadingColor
}

export const Container = styled.div<{ heightClass: HeightClass }>`
  width: 100%;
  height: ${({ heightClass, theme }) =>
    theme.progressBar[heightClass].totalHeight}px;
  background-color: ${({ theme }) => theme.progressBar.backgroundColor};
  border-radius: ${({ heightClass, theme }) =>
    theme.progressBar[heightClass].totalHeight / 2}px;
`

export const ProgressContent = styled.div<{
  heightClass: HeightClass
  progress: number
  isError?: boolean
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: ${({ heightClass, theme }) =>
    theme.progressBar[heightClass].totalHeight}px;

  color: ${({ isError }) =>
    isError ? ColorPalette.whiteText : ColorPalette.blackText};
  background-color: ${({ progress, theme, isError }) =>
    validationBgColor(progress, theme, isError)};
  transition: width 0.5s linear 0s;
  border-radius: ${({ heightClass, theme }) =>
    theme.progressBar[heightClass].totalHeight / 2}px;
  padding: ${({ heightClass, progress, theme }) =>
      progress ? theme.progressBar[heightClass].verticalPadding : 0}px
    0;
`
